var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatures8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M462.07 163.47C419.28 173.22 358.83 130.66 324.83 102.69C292.11 130.69 230.44 173.3 187.64 163.59C186.63 163.34 178.57 161.4 177.57 161.16C163.77 279.18 205.36 403.26 324.98 445.8C443.29 403.16 486.04 279.04 472.14 161.03C470.13 161.52 463.08 163.23 462.07 163.47ZM449.53 265.68C441.89 265.68 403.7 265.7 334.97 265.72C334.94 186.88 334.92 143.08 334.91 134.32C360.1 153.78 410.47 186.61 455.79 182.94C457.05 198.76 457.07 230.39 449.53 265.68ZM314.77 134.33C314.78 143.09 314.79 186.89 314.83 265.73C246.09 265.76 207.91 265.78 200.27 265.78C193.96 229.28 193.95 197.65 193.94 183.05C238 186.68 289.6 153.81 314.77 134.33ZM316.09 283.98C316.13 366.47 316.15 412.3 316.15 421.47C249.42 393.51 219.18 336.34 205.31 284.03C220.08 284.02 257.01 284.01 316.09 283.98ZM334.98 283.97C401.45 283.95 438.37 283.93 445.76 283.93C430.68 336.25 400.49 393.45 335.04 421.46C335.03 403.13 335.01 357.3 334.98 283.97Z",
    id: "aoB0E3PFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.39 103.76L531.39 1.94L109.58 1.94L109.58 102.79L17.45 102.79L17.45 505.21L623.52 505.21L623.52 103.76L531.39 103.76ZM72.73 452.85L72.73 157.09L109.58 157.09L109.58 452.85L72.73 452.85ZM516.85 96L516.85 452.85L124.12 452.85L124.12 96L516.85 96ZM568.24 157.09L568.24 452.85L531.39 452.85L531.39 157.09L568.24 157.09ZM516.85 81.45L124.12 81.45L124.12 16.48L516.85 16.48L516.85 81.45ZM608.97 491.64L32 491.64L32 118.3L109.58 118.3L109.58 142.55L58.18 142.55C58.18 337.45 58.18 445.74 58.18 467.39C162.91 467.39 477.09 467.39 581.82 467.39C581.82 445.74 581.82 337.45 581.82 142.55L530.42 142.55L530.42 118.3L608 118.3L608 491.64L608.97 491.64Z",
    id: "j3E53hDbWx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91 590.55C2.91 616.73 24.24 637.09 49.45 637.09C434.42 637.09 201.7 637.09 591.52 637.09C617.7 637.09 638.06 615.76 638.06 590.55C638.06 586.02 638.06 563.39 638.06 522.67L2.91 522.67C2.91 563.39 2.91 586.02 2.91 590.55ZM274.42 589.58L366.55 589.58L379.15 622.55L261.82 622.55L274.42 589.58ZM591.52 622.55C578.33 622.55 512.39 622.55 393.7 622.55L376.24 575.03L263.76 575.03L246.3 622.55C128.19 622.55 62.58 622.55 49.45 622.55C32 622.55 17.45 608 17.45 590.55C17.45 586.99 17.45 569.21 17.45 537.21L623.52 537.21L623.52 590.55C613.82 611.88 603.15 622.55 591.52 622.55Z",
    id: "k1C1uBoI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.85 49.45C324.85 37.82 315.15 28.12 303.52 28.12C291.88 28.12 282.18 37.82 282.18 49.45C282.18 61.09 290.91 70.79 303.52 70.79C315.15 70.79 324.85 61.09 324.85 49.45ZM310.3 49.45C310.3 53.33 307.39 56.24 303.52 56.24C299.64 56.24 296.73 53.33 296.73 49.45C296.73 45.58 299.64 42.67 303.52 42.67C307.39 42.67 310.3 45.58 310.3 49.45Z",
    id: "b113pE840g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.76 49.45C263.76 37.82 254.06 28.12 242.42 28.12C230.79 28.12 221.09 37.82 221.09 49.45C221.09 61.09 230.79 70.79 242.42 70.79C254.06 70.79 263.76 61.09 263.76 49.45ZM249.21 49.45C249.21 53.33 246.3 56.24 242.42 56.24C238.55 56.24 235.64 53.33 235.64 49.45C235.64 45.58 238.55 42.67 242.42 42.67C246.3 42.67 249.21 45.58 249.21 49.45Z",
    id: "b22XWbV5QL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.64 49.45C203.64 37.82 193.94 28.12 182.3 28.12C170.67 28.12 160.97 37.82 160.97 49.45C160.97 61.09 170.67 70.79 182.3 70.79C193.94 70.79 203.64 61.09 203.64 49.45ZM189.09 49.45C189.09 53.33 186.18 56.24 182.3 56.24C178.42 56.24 175.52 53.33 175.52 49.45C175.52 45.58 178.42 42.67 182.3 42.67C186.18 42.67 189.09 45.58 189.09 49.45Z",
    id: "bXd56jo0I"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aoB0E3PFF",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aoB0E3PFF",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j3E53hDbWx",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j3E53hDbWx",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k1C1uBoI",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k1C1uBoI",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b113pE840g",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b113pE840g",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b22XWbV5QL",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b22XWbV5QL",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bXd56jo0I",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bXd56jo0I",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures8);
export default __webpack_public_path__ + "static/media/features-8.dda7a85036ae125f7226582f4967ba24.svg";
export { ForwardRef as ReactComponent };